import styled from "styled-components";

import { ConsolePageButtonContainer } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";

export const EditorFeedCommenterInfoContainer = styled.div`
  display: flex;
`;

export const EditorFeedCommenterInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CommenterUserName = styled.span`
  color: ${({ theme }) => theme.lexicalEditor.fontPrimaryColor};
  font: 600 0.813rem/0.875rem "Inter";
  line-height: 19.5px;
`;

export const CommenterUserTitle = styled.p`
  all: unset;

  color: ${({ theme }) => theme.commentsFeed.fontSecondaryColor} !important;
  font: 400 0.813rem/0.875rem "Inter";
  line-height: 17.5px;
`;

export const EditorFeedOptionsButtonContainer = styled.div`
  position: relative;

  display: flex;
  gap: 0.5rem;
  flex-direction: row-reverse;

  ${ConsolePageButtonContainer} > svg * {
    fill: ${({ theme }) => theme.lexicalEditor.fontPrimaryColor};
    stroke: ${({ theme }) => theme.lexicalEditor.fontPrimaryColor};
  }

  .editor-feed-button-options {
    padding: 0.5rem;
    rotate: 90deg;

    :hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.commentsFeed.editorBorder};
    }
  }
`;

export const PrivateMessage = styled.div`
  all: unset;

  width: fit-content;
  text-wrap: nowrap;
  align-items: center;
  display: flex;
  gap: 0.5rem;

  font: 500 0.75rem/0.815rem "Inter";
  color: ${({ theme }) => theme.commentsFeed.privateFontColor};

  svg * {
    fill: ${({ theme }) => theme.commentsFeed.privateFontColor};
  }

  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

export const PendingReviewMessage = styled.div`
  all: unset;

  width: fit-content;
  text-wrap: nowrap;
  align-items: center;
  display: flex;
  gap: 0.5rem;
  border-radius: 4px;

  padding: 0.5rem;
  background-color: ${({ theme }) => theme.commentsFeed.privateBackgroundColor};

  font: 500 0.75rem/0.815rem "Inter";
  color: ${({ theme }) => theme.groups.primaryText};

  svg * {
    fill: ${({ theme }) => theme.groups.primaryText};
  }

  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;
